import { createElementBlock as l, openBlock as a, createElementVNode as n } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(t, e) {
  return a(), l("svg", o, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9 3a1 1 0 0 1-2 0V2a1 1 0 1 1 2 0zM5.041 8C4.466 8 4 8.466 4 9.041v.885h16v-.885C20 8.466 19.534 8 18.959 8zM2 10.796q0 .033.002.065L2 10.926a1 1 0 0 0 1 1h18a1 1 0 0 0 .998-1.065l.002-.065V9.04A3.04 3.04 0 0 0 18.959 6H5.04A3.04 3.04 0 0 0 2 9.041zm1 3.13a1 1 0 0 1 1 1v5.106c0 .575.466 1.042 1.041 1.042H18.96c.575 0 1.041-.467 1.041-1.042v-5.106a1 1 0 1 1 2 0v5.106a3.04 3.04 0 0 1-3.041 3.042H5.04A3.04 3.04 0 0 1 2 20.032v-5.106a1 1 0 0 1 1-1M16 4a1 1 0 0 0 1-1V2a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1m-.747 11.159a1 1 0 0 0-1.506-1.318l-2.796 3.196-.744-.744a1 1 0 0 0-1.414 1.414l1.5 1.5a1 1 0 0 0 1.46-.049z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const v = { render: r };
export {
  v as default,
  r as render
};
//# sourceMappingURL=ic_calendar_check-CQCzlJrX.js.map
